// Telegram admin helper functions — extracted from App.jsx (C1 refactor, Phase 2d3a).
//
// Behavior-preserving move: both functions are byte-identical to their former
// App.jsx declarations. They are thin fetch wrappers used by the admin panel
// (Telegram connectivity test + manual notification trigger).
//
// Dependencies imported from already-extracted modules (no App.jsx coupling):
//   • API_BASE     -> ./endpoints.js
//   • authHeaders  -> ./auth-headers.js
import { API_BASE } from './endpoints.js';
import { authHeaders } from './auth-headers.js';

export async function telegramTest() {
  try {
    const res = await fetch(`${API_BASE}/telegram/test`, { headers: authHeaders(), signal: AbortSignal.timeout(4000) });
    return await res.json();
  } catch (e) {
    return { status: "error", error: e.message };
  }
}

export async function telegramNotify(message) {
  try {
    const res = await fetch(`${API_BASE}/telegram/notify`, {
      method: 'POST', headers: authHeaders(),
      body: JSON.stringify({ message }), signal: AbortSignal.timeout(4000),
    });
    return await res.json();
  } catch (e) {
    return { error: e.message };
  }
}
